import type { ProviderInfo } from '~/types/model';

type AskUserResponse = {
  questionId: string;
  question: string;
  answer: string;
};

export function buildAskUserResponseMessage({
  answers,
  sessionKey,
  model,
  provider,
}: {
  answers: AskUserResponse[];
  sessionKey?: string;
  model?: string;
  provider?: ProviderInfo;
}) {
  const answerText = answers.map((answer) => `**${answer.question}:** ${answer.answer}`).join('\n\n');

  const text =
    model && provider
      ? `[Model: ${model}]\n\n[Provider: ${provider.name}]\n\nHere are my answers:\n\n${answerText}\n\nPlease proceed with the plan and implementation.`
      : `Here are my answers:\n\n${answerText}\n\nPlease proceed with the plan and implementation.`;

  return {
    text,
    metadata: {
      askUserResponse: {
        type: 'askUserResponse',
        answers,
        source: 'ask_user_ui',
        sessionKey,
      },
    },
  };
}
